import { createSelector } from 'reselect';

const selectGlobalDbnServiceCategories = (state: any) => state.globalDbnServiceCategories;


export const selectGlobalDbnServiceCategoriesCurrentItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.current);

export const selectGlobalDbnServiceCategoriesListItems = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDbnServiceCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDbnServiceCategoriesQueryItems = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.query);

export const selectGlobalDbnServiceCategoriesCreatedItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.create);

export const selectGlobalDbnServiceCategoriesPublishedItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.publish);

export const selectGlobalDbnServiceCategoriesCompareItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.compare);

export const selectGlobalDbnServiceCategoriesUpdatedItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.update);

export const selectGlobalDbnServiceCategoriesReadItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.read);

export const selectGlobalDbnServiceCategoriesDeletedItem = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.delete);

export const selectGlobalDbnServiceCategoriesSearchedItems = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.search);

export const selectGlobalDbnServiceCategoriesItemsCount = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.count);

export const selectGlobalDbnServiceCategoriesItemsFilter = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.filter);

export const selectGlobalDbnServiceCategoriesAccountMappingsListItems = createSelector([selectGlobalDbnServiceCategories], (globalDbnServiceCategories) => globalDbnServiceCategories.accountMappingslist);
